import { Box, Typography } from "@mui/material";

export const MapDataLoadingPanel = ({ isLoading }: { isLoading?: boolean }) => {
  return (
    <Box>
      {isLoading && (
        <Box
          className='leaflet-control'
          sx={[
            (theme) => ({
              backgroundColor: theme.palette.background.default,
            }),
            {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 1,
              padding: 1,
              boxShadow: '0 0 5px rgba(0,0,0,0.3)',
              minWidth: 100,
              minHeight: 20,
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }
          ]}
        >
          <Typography variant='subtitle1' sx={{ textAlign: 'center'}}>{'Loading data...'}</Typography>
        </Box>
      )}
    </Box>
  )
};
